{
  "id": "campaign-105",
  "name": "Regal Grounds",
  "seed": "campaign:105",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "..,ACCCCCCCCA...",
    ".,,,C.T..T.C....",
    "....C......C....",
    ".B..C......C..B.",
    "....C......C....",
    "www++wwwwww++www",
    "....C.*..*.C....",
    "....Ch*ww*hC....",
    ".%%.C.*ww*.C.%%.",
    ".~%.C......C.%..",
    "~.~.Cx.....C....",
    ".~..C......C....",
    "..T.C....x.C.T..",
    "...tCCCCCCCCt...",
    "................",
    ".........x.....S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 3,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 14
    },
    {
      "kind": "rabbit",
      "x": 2,
      "y": 2
    },
    {
      "kind": "rabbit",
      "x": 12,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 12,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 3
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 105,
  "biome": "estate",
  "par": {
    "reel": 7367,
    "push": 6411,
    "selfPropelled": 6060,
    "tractor": 4750,
    "zeroTurn": 4195,
    "fairway": 3252
  },
  "goldTime": {
    "reel": 7022,
    "push": 6047,
    "selfPropelled": 5796,
    "tractor": 4650,
    "zeroTurn": 4102,
    "fairway": 2911
  },
  "routeTries": {
    "par": {
      "reel": 20,
      "push": 13,
      "selfPropelled": 0,
      "tractor": 19,
      "zeroTurn": 11,
      "fairway": 19
    },
    "gold": {
      "reel": 34,
      "push": 38,
      "selfPropelled": 34,
      "tractor": 34,
      "zeroTurn": 27,
      "fairway": 42
    }
  }
}
